<template>
  <div class="result__header">
    <div class="result__header-mobile-bar  hide-in-desktop">
      <button class="btn btn--light" @click="toggleFilterMobile">
        <i class="icon-filter" />
        <span>فیلتر</span>
      </button>

      <button @click="toggleSort" class="btn btn--light">
        <i class="icon-sort" />
        <span>مرتب‌ سازی</span>
      </button>
    </div>

    <div @click="outSideSortClick" v-show="isOpen" class="result__nav-head-sort-content">
      <div class="result__nav-head-sort-items hide-in-desktop">
        <span>مرتب‌سازی</span>

        <button @click="toggleSort" class="btn">
          <i class="icon-close " />
        </button>
      </div>
      <div class="result__order-list" ref="sortContent">
        <div class="result__order-list-title hide-in-not-desktop">
          <i class="icon-sort" />
          <span>مرتب کردن</span>
        </div>

        <div v-for="(sortItem, i) in sortItems" :key="i">
          <input
            name="sort"
            :id="'sort' + sortItem.id"
            :checked="sortItemActive === sortItem.id"
            @change="sortItemChange(sortItem.id)"
            class="checkmark"
            type="radio"
          />
          <label :for="'sort' + sortItem.id">{{ sortItem.title }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const root = document.getElementsByTagName("html")[0];
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ResultNav",

  data() {
    return {
      sortItems: [
        { title: "ارزان ترین", id: "minPrice", selected: true },
        { title: "گران ترین", id: "maxPrice", selected: false },
        { title: "طولانی ترین", id: "maxDuration", selected: false },
        { title: "کوتاه ترین", id: "minDuration", selected: false },
        { title: "نزدیک ترین", id: "closest", selected: false },
      ],
      sortItemActive: "minPrice",
      showSort: false,
      isOpen: window.outerWidth < 992 ? false : true,
    };
  },

  mounted() {
    this.sortItemChange("minPrice");
  },
  methods: {
    ...mapActions(["toggleFilterBoxMobile"]),

    toggleFilterMobile() {
      this.toggleFilterBoxMobile();
    },

    sortItemChange(sortId) {
      this.sortItemActive = sortId;
      this.$emit("sort", sortId);
      if (screen.width < 992) {
        this.isOpen = false;
      }
    },

    toggleSortBox() {
      this.showSort = !this.showSort;
    },

    toggleSort() {
      if (screen.width < 992) {
        this.isOpen = !this.isOpen;
        this.toggleNoScroll();
      }
    },

    toggleNoScroll() {
      root.classList.toggle("no-scroll");
    },

    closeSort() {
      this.isOpen = false;
    },

    outSideSortClick(e) {
      if (!this.$refs.sortContent.contains(e.target) && screen.width < 992) {
        this.closeSort();
        this.toggleNoScroll();
      }
    },
  },
};
</script>

<style lang="scss">
@import "../style/modules/result.scss";
</style>
